import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_fe0544c3: FaireBrandEntity = {
  token: "b_fe0544c3",
  type: "brand",
  name: "Michelle Starbuck Designs",
  avatarUrl:
    "https://cdn.faire.com/fastly/c0a6b9514c18f56363190fe6ec75346929081249a977a2bc0a6d274aa286959d.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7144b7cc2134e3f4fe2af10f57dd7eaacd45c82fd608f6e06d87571f6c4ecd2a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c0a6b9514c18f56363190fe6ec75346929081249a977a2bc0a6d274aa286959d.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7144b7cc2134e3f4fe2af10f57dd7eaacd45c82fd608f6e06d87571f6c4ecd2a.jpeg",
  location: "Chicago, IL, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 37,
  isTopShop: true,
  isInsider: true,
  description:
    "Charmingly eclectic jewelry.  Handmade in Chicago since 2005.  Michelle Starbuck Designs blends old and new, using a mix of vintage metals and gemstones, and enamel resin.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:38:33.550Z",
    importedBy: "entity-db-cli",
  },
};
